import {Component, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'la-tag',
  template: `
    <button type="button" class="la-tag">
      <ng-content></ng-content>
    </button>`,
  styles: [`
    .la-tag{padding:0 16px 1px;height:32px;color:rgba(3,20,34,.55);border:1px solid rgba(3,20,34,.1);background:#fff;border-radius:16px;cursor:pointer;font-family:NeueHaasUnicaPro,sans-serif;font-size:14px;font-weight:500;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:-.3px}.la-tag la-icon{position:relative;top:-1px;margin-left:4px}button:focus{outline:none}
  `],
  encapsulation: ViewEncapsulation.None
})
export class LaTagComponent {
}
